import { render, staticRenderFns } from "./speaking.vue?vue&type=template&id=a3828b98&scoped=true&"
import script from "./speaking.vue?vue&type=script&lang=js&"
export * from "./speaking.vue?vue&type=script&lang=js&"
import style1 from "./speaking.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3828b98",
  null
  
)

export default component.exports